import(/* webpackMode: "eager" */ "/app/apps/publicWeb/src/app/error.tsx");
